const state = {
    list: [],
    errors: []
}

export default state
